import React from "react";

import FormBackAndContinueButton from "../MemberRegisterForms/FormBackAndContinueButton";
import { scrollToTop } from "../../utilities";
import { FullYellowSmallSun } from "../../utilities/svg";

const MentorRegistrationFeatures = ({
  changeToNextPage,
  onBackButtonClick,
  continueButtonloader,
  backButtonLoader,
  //   mentorRegisterData,
}) => {
  const handleBackButtonClick = () => {
    onBackButtonClick("personal_information_page");
    scrollToTop("50", "16.66");
  };

  window.location.hash = 'step2';

  return (
    <section className="homepageWidth md:w-70% mx-auto pt-4 mb-6 ">
      <h1
        className="font-bold text-4xl text-center sm:mt-8 my-8"
        style={{ color: "#093B5D" }}
      >
        Merity Coach Compensation Guide
      </h1>

      <h2 className="mb-6 mt-6 text-3xl font-bold">
        Core Services
      </h2>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          changeToNextPage("professional_information_page");
        }}
        className="px-2"
      >

        <h2 className="mb-6 font-bold text-xl">
          One-on-One Coaching
        </h2>

        <div className="flex flex-col gap-4">
          {coaching.map(({ title, description }, index) => (
            <div className="flex gap-2" key={index}>
              <FullYellowSmallSun
                style={{ minWidth: "34px", minHeight: "34px" }}
              />
              <p
                className="font-extrabold text-brandDarkBlue text-base 500px:text-lg"
                key={index}
              >
                <b className="font-bold">{title} </b>
                <span className="font-medium">{description}</span>
              </p>
            </div>
          ))}
        </div>

        <h2 className="mb-6 mt-6 font-bold text-xl">
          Group Support Sessions
        </h2>

        <div className="flex flex-col gap-4">
          {group_session.map(({ title, description }, index) => (
            <div className="flex gap-2" key={index}>
              <FullYellowSmallSun
                style={{ minWidth: "34px", minHeight: "34px" }}
              />
              <p
                className="font-extrabold text-brandDarkBlue text-base 500px:text-lg"
                key={index}
              >
                <b className="font-bold">{title} </b>
                <span className="font-medium">{description}</span>
              </p>
            </div>
          ))}
        </div>

        <h2 className="mb-6 mt-6 font-bold text-xl">
          Premium Content Opportunities
        </h2>

        <div className="flex flex-col gap-4">
          {premium_content.map(({ title, description }, index) => (
            <div className="flex gap-2" key={index}>
              <FullYellowSmallSun
                style={{ minWidth: "34px", minHeight: "34px" }}
              />
              <p
                className="font-extrabold text-brandDarkBlue text-base 500px:text-lg"
                key={index}
              >
                <b className="font-bold">{title} </b>
                <span className="font-medium">{description}</span>
              </p>
            </div>
          ))}
        </div>

        <div className="w-96% md:w-1/2 mx-auto my-12">
          <FormBackAndContinueButton
            onBackButtonClick={handleBackButtonClick}
            actionBegin={continueButtonloader}
            backButtonLoader={backButtonLoader}
          />
        </div>
      </form>
    </section>
  );
};

export default MentorRegistrationFeatures;

const coaching = [
  {
    title: "Rate:",
    description:
      "$75 per hour",
  },
  {
    title: "Format:",
    description:
      "Individual coaching sessions on Zoom",
  },
  {
    title: "Scheduling:",
    description:
      "Sessions booked in 15-minute intervals",
  },
  {
    title: "Purpose:",
    description:
      "Support members working through the Merity curriculum and general coaching needs",
  },
  {
    title: "Billing:",
    description:
      "Calculated in minute increments",
  },
  {
    title: "Payment:",
    description:
      "Processed monthly",
  }
];


const group_session = [
  {
    title: "Rate:",
    description:
      "$100 per session",
  },
  {
    title: "Duration:",
    description:
      "60 minutes",
  },
  {
    title: "Format:",
    description:
      "Zoom group sessions",
  },
  {
    title: "Role:",
    description:
      "Moderate and facilitate group discussion",
  },
  {
    title: "Payment:",
    description:
      "Processed monthly",
  }
];


const premium_content = [
  {
    title: "Eligible Content:",
    description:
      "Webinars, Workshops, Toolkits, Educational Resources",
  },
  {
    title: "Compensation:",
    description:
      "Custom rates negotiated per project",
  },
  {
    title: "Revenue Share:",
    description:
      "80% to coach, 20% to Merity",
  },
  {
    title: "Marketing:",
    description:
      "Full promotion through Merity network",
  },
  {
    title: "Submission:",
    description:
      "Present ideas to Merity team for review",
  }
];
